import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Footer() {
  return (
    <footer className="bg-background-900 border-t border-background-800/60">
      <div className="w-full px-4 md:px-6">
        <div className="py-12 md:py-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Brand */}
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-movie-2-line text-background-950 text-base"></i>
                </div>
                <span className="text-lg font-heading font-bold text-foreground-50 whitespace-nowrap">
                  91电影视频
                </span>
              </Link>
              <p className="text-sm text-foreground-500 leading-relaxed">
                海量免费电影、电视剧、综艺在线观看，无需注册，即点即播，高清不缓冲，每日更新最新剧集。
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-sm font-heading font-semibold text-foreground-200 mb-4">
                快速导航
              </h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors">
                  首页
                </Link>
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-500 hover:text-primary-400 transition-colors"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>

            {/* Help */}
            <div>
              <h4 className="text-sm font-heading font-semibold text-foreground-200 mb-4">
                帮助中心
              </h4>
              <div className="flex flex-col gap-2.5">
                <button className="text-sm text-foreground-500 hover:text-primary-400 transition-colors text-left cursor-pointer">
                  常见问题
                </button>
                <button className="text-sm text-foreground-500 hover:text-primary-400 transition-colors text-left cursor-pointer">
                  播放帮助
                </button>
                <button className="text-sm text-foreground-500 hover:text-primary-400 transition-colors text-left cursor-pointer">
                  意见反馈
                </button>
                <Link to="/about" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors">
                  关于我们
                </Link>
              </div>
            </div>

            {/* Contact */}
            <div>
              <h4 className="text-sm font-heading font-semibold text-foreground-200 mb-4">
                联系我们
              </h4>
              <div className="flex flex-col gap-2.5">
                <p className="text-sm text-foreground-500">
                  <i className="ri-mail-line mr-2"></i>
                  contact@91movie.com
                </p>
                <p className="text-sm text-foreground-500">
                  <i className="ri-customer-service-2-line mr-2"></i>
                  在线客服：7x24小时
                </p>
                <div className="flex gap-4 mt-3">
                  <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500/20 text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer" aria-label="微博">
                    <i className="ri-weibo-line text-base"></i>
                  </a>
                  <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500/20 text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer" aria-label="微信">
                    <i className="ri-wechat-line text-base"></i>
                  </a>
                  <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500/20 text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer" aria-label="抖音">
                    <i className="ri-tiktok-line text-base"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="py-6 border-t border-background-800/50">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-600">
              &copy; 2026 91电影视频 - 91影视看片免费 · 91免费在线视频 · 91电影在线观看
            </p>
            <div className="flex items-center gap-4 flex-wrap">
              <a href="#" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors">隐私政策</a>
              <a href="#" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors">服务条款</a>
              <a href="#" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors">版权声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}